'use strict';

namespace Core {

    class SelectBoxItem {
        element: JQuery;
        index: number;
        value: string;
        label: string;
        disabled: boolean;
    }

    let selectBoxItemId: number = 0;

    class SelectBox {

        // Attrs
        private model: any;
        private labelText: string;
        private iconName: string;

        // elements
        private element: JQuery;
        private wrapper: JQuery;
        private button: JQuery;
        private buttonText: JQuery;
        private menu: JQuery;
        private menuItems: JQuery;

        // data
        private selectBoxItems: SelectBoxItem[];
        private eventNamespace = 'selectbox';
        private ids: any;
        private isOpen: boolean = false;
        private isMenuRendered: boolean = false;
        private previousFilter: string;
        private filterTimer: any;

        private buttonEvents = {
            'click': (event) => {
                this.toggle(event);
            },
            'keydown': (event) => {
                let preventDefault = true;
                switch (event.keyCode) {
                    // Tab / Escape
                    case 9:
                    case 27:
                        this.close();
                        preventDefault = false;
                        break;
                    // Enter
                    case 13:
                        this.toggle(event);
                        break;
                    // Up
                    case 38:
                        if (event.altKey) {
                            this.toggle(event);
                        } else {
                            this.move('prev', event);
                        }
                        break;
                    // Down
                    case 40:
                        if (event.altKey) {
                            this.toggle(event);
                        } else {
                            this.move('next', event);
                        }
                        break;
                    // Home / Page Up
                    case 36:
                    case 33:
                        this.move('first', event);
                        break;
                    // End / Page Down
                    case 35:
                    case 34:
                        this.move('last', event);
                        break;
                    default:

                        const prev: string = this.previousFilter || '';
                        let skip: boolean = false;

                        // Support number pad values
                        let character: string = event.keyCode >= 96 && event.keyCode <= 105 ?
                            (event.keyCode - 96).toString() : String.fromCharCode(event.keyCode);

                        clearTimeout(this.filterTimer);

                        if (character === prev) {
                            skip = true;
                        } else {
                            character = prev + character;
                        }

                        let matching: SelectBoxItem[] = this.filterMenuItems(character);

                        //match = skip && match.index(this.active.next()) !== -1 ?
                        // this.active.nextAll( ".ui-menu-item" ) : match;

                        // If no matches on the current filter, reset to the last character pressed
                        // to move down the menu to the first item that starts with that character
                        if (!matching.length) {
                            character = String.fromCharCode(event.keyCode);
                            matching = this.filterMenuItems(character);
                        }

                        if (matching.length) {
                            const match: SelectBoxItem = matching[0];
                            this.select(match);
                            this.previousFilter = character;

                            this.filterTimer = setTimeout(() => {
                                delete this.previousFilter;
                            }, 1000);

                        } else {
                            delete this.previousFilter;
                        }

                        //this.menu.trigger(event);
                        preventDefault = false;
                }
                preventDefault && event.preventDefault();
            }
        };

        private menuEvents = {
            'mousedown': (event) => {
                // Prevent the menu from recieving focus. We want to retain focus on the button.
                event.preventDefault();
                const menuItem = $(event.currentTarget);
                this.select(menuItem.data('SelectBoxItem'));
                this.close();
            },
            'mouseover': (event) => {
                const menuItem = $(event.currentTarget);
                this.setActiveItem(menuItem);
            }
        };

        constructor (
            private $scope: ng.IScope,
            private $document: ng.IAugmentedJQuery
        ) {
        }

        init (el, attrs): void {
            this.element = el;

            const id = this.element.attr('id');
            this.ids = {
                element: id,
                button: id + '-button',
                menu: id + '-menu'
            };

            this.drawWrapper();
            this.drawButton();
            this.drawMenu();

            // watch the model
            this.$scope.$watch('sb.model', (val, old) => {
                this.setButtonText();
                if (this.isMenuRendered) {
                    this.setActiveItem(this.getSelectedMenuItem());
                }
            });

            this.$scope.$on('$destroy', () => {
                // unbind event listeners by namespace
                this.button.off('.' + this.eventNamespace);
                this.menu.off('.' + this.eventNamespace);
            });
        }

        private drawWrapper(): void {
            const div = $('<div>').addClass('select-box');
            this.element.wrap(div);
            this.wrapper = this.element.parent();
        }

        private drawButton(): void {
            // Hide the original select element
            this.element.hide();

            // Create new button
            this.button = $('<span>', {
                class: 'select-box-button',
                tabindex: 0,
                id: this.ids.button,
                role: 'combobox',
                'aria-expanded': 'false',
                'aria-autocomplete': 'list',
                'aria-owns': this.ids.menu,
                'aria-haspopup': 'true',
                title: this.element.attr('title')
            }).insertAfter(this.element);

            const label = $('<span>', {
                class: 'select-box-button-label'
            }).appendTo(this.button);

            // pre-text
            if (this.labelText) {
                $('<span>', {
                    class: 'select-box-pre-text',
                    text: this.labelText + ':'
                }).appendTo(label);
            }

            // dynamic text (matches selected option)
            this.buttonText = $('<span>', {
                class: 'select-box-text'
            }).appendTo(label);

            // // icon
            // if (this.iconName) {
            //     $('<i>', {
            //         class: 'select-box-icon icon-' + this.iconName
            //     }).appendTo(this.button);
            // }

            // assign button event listeners
            _.forEach(this.buttonEvents, (handler, eventName) => {
                this.button.on(eventName + '.' + this.eventNamespace, handler);
            });
            this.button.one('focusin', () => {
                // Rendering the menu items when the button receives focus
                this.refreshMenu();
            });
        }

        private drawMenu(): void {
            // Create menu
            this.menu = $('<ul>', {
                    'aria-hidden': 'true',
                    'aria-labelledby': this.ids.button,
                    id: this.ids.menu
                });

            const menuWrap = $('<div>', {
                    class: 'select-box-menu'
                })
                .append(this.menu)
                .insertAfter(this.button);

            // assign menu event listeners
            _.forEach(this.menuEvents, (handler, eventName) => {
                this.menu.on(eventName + '.' + this.eventNamespace, '.select-box-option', handler);
            });
        }

        public toggle(event): void {
           if(this.isOpen) {
               this.close();
           } else {
               this.open(event);
           }
        }

        public open(event): void {
            this.isOpen = true;
            this.setOpen();

            this.setActiveItem(this.getSelectedMenuItem());

            // close if document is clicked
            this.$document.on('mousedown.' + this.eventNamespace, (event) => {
                if (!this.isOpen) {
                    return;
                }
                if (!$(event.target).closest('.select-box-menu, #' + this.ids.button).length) {
                    this.close();
                }
            });
        }

        public close(): void {
            if (!this.isOpen) {
                return;
            }
            this.isOpen = false;
            this.setOpen();
            this.$document.off('.' + this.eventNamespace);
        }

        private refreshMenu(): void {
            this.menu.empty();

            // get the native select options
            const options: JQuery = this.element.find('option');
            this.parseOptions(options);

            this.renderMenu(this.menu, this.selectBoxItems);
            this.menuItems = this.menu.find('.select-box-option');

            // set the active menu item
            const menuItem = this.getSelectedMenuItem();
            this.isMenuRendered = true;
            this.setActiveItem(menuItem);
        }

        private renderMenu(ul: JQuery, items: SelectBoxItem[]): void {
           _.each(items, (item, index) => {
               this.renderItem(ul, item);
           });
        }

        private renderItem(ul: JQuery, item: SelectBoxItem): void {
            selectBoxItemId += 1; // unique id across all instances

            // create new menu item
            let li: JQuery = $('<li>');
            let menuItem: JQuery = $('<div>', {
                id: 'select-box-option-' + selectBoxItemId,
                role: 'option',
                class: 'select-box-option'
            });

            // set text
            this.setText(menuItem, item.label);
            // tag data
            menuItem.data('SelectBoxItem', item);
            // append to menu
            li.append(menuItem).appendTo(ul);
        }

        private parseOptions(options: JQuery): void {
            let data:any = [];
            options.each((index, item) => {
                data.push(this.parseOption($(item), index));
            });
            this.selectBoxItems = data;
        }

        private parseOption(option: JQuery, index: number): any {
            let item = new SelectBoxItem;
            item.element = option;
            item.index = index;
            item.value = option.val();
            item.label = option.text();
            item.disabled = option.prop('disabled');
            return item;
        }

        private getSelectedMenuItem(): JQuery {
            // get the menu item corresponding to the native selected option
            return this.menuItems.eq((<HTMLSelectElement>this.element[0]).selectedIndex);
        }

        private setOpen(): void {
            this.button.attr('aria-expanded', String(this.isOpen));
            this.menu.attr('aria-hidden', String(!this.isOpen));
            if(this.isOpen) {
                this.wrapper.addClass('select-box-open');
            } else {
                this.wrapper.removeClass('select-box-open');
            }
        }

        private setText(element: JQuery, value): void {
            if (value) {
                element.text(value);
            } else {
                element.html('&#160;');
            }
        }

        private move(direction: string, event): void {
            const index: number = (<HTMLSelectElement>this.element[0]).selectedIndex;
            const current: JQuery = this.menuItems.eq(index);
            const filter: string = '.select-box-option';

            let nextIndex: any = undefined;

            switch (direction) {
                case 'prev':
                    nextIndex = index - 1;
                    break;
                case 'next':
                    nextIndex = index + 1;
                    break;
                case 'first':
                    nextIndex = 0;
                    break;
                case 'last':
                    nextIndex = this.menuItems.length - 1;
                    break;
                default:
            }

            if (nextIndex > -1 && nextIndex < (this.menuItems.length)) {
                const menuItem = this.menuItems.eq(nextIndex);
                this.select(menuItem.data('SelectBoxItem'));
            }
        }

        private setActiveItem(menuItem: JQuery): void {
            // highlight this menu item
            const className = 'select-box-option-active';
            this.menuItems.filter('.' + className).removeClass(className);
            menuItem.addClass(className);

            // set the focus index
            let selectBoxItem = menuItem.data('SelectBoxItem');

            this.setAriaActive(selectBoxItem);
        }

        private select(item: SelectBoxItem): void {
            // Change the native select element
            (<HTMLSelectElement>this.element[0]).selectedIndex = item.index;
            // let angular know that the select box has changed programattically
            // this will trigger the model update
            this.element.trigger('change');
        }

        private setAriaActive(item: SelectBoxItem): void {
            const id = this.menuItems.eq(item.index).attr('id');
            this.button.attr({
                'aria-labelledby': id,
                'aria-activedescendant': id
            } );
            this.menu.attr('aria-activedescendant', id);
        }

        private filterMenuItems(character: string): SelectBoxItem[] {
            const escapedCharacter = character.replace( /[\-\[\]{}()*+?.,\\\^$|#\s]/g, '\\$&' ),
                regex = new RegExp( '^' + escapedCharacter, 'i' );
            const matching = _.filter(this.selectBoxItems, (item: SelectBoxItem) => {
                return regex.test(item.label);
            });
            return matching;
        }

        private setButtonText(): void {
            // get the selected item from the native control
            const selectBoxItem = this.parseOption(
                this.element.find('option:selected'),
                (<HTMLSelectElement>this.element[0]).selectedIndex
            );
            // set the button text
            this.setText(this.buttonText, selectBoxItem.label);
        }

    }

    angular
        .module('core')
        .directive('selectBox', (): ng.IDirective => {
            return {
                restrict: 'A',
                scope: {},
                replace: true,
                controller: SelectBox,
                controllerAs: 'sb',
                bindToController: {
                    model: '=ngModel',
                    labelText: '@labelText',
                    iconName: '@iconName'
                },
                link: (
                    scope: ng.IScope,
                    el: ng.IAugmentedJQuery,
                    attrs: ng.IAttributes,
                    controller : SelectBox
                ) => {
                    controller.init(el, attrs);
                }
            };
        });

}
